import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRltLMRAShowQuery } from "@/services/backend/rlt/work-orders/api/lmra-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { ConfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/confirmed-lmra";
import { UnconfirmedLMRAComponent } from "@/services/backend/rlt/work-orders/components/unconfirmed-lmra";

export function WorkOrderExecutionLmraRoute() {
  const { lmraId } = useParams();
  const {
    data: lmra,
    isLoading,
    error,
  } = useRltLMRAShowQuery({
    id: lmraId!,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!lmra) return null;

  if (lmra.confirmed) {
    return <ConfirmedLMRAComponent lmra={lmra} />;
  }
  return <UnconfirmedLMRAComponent lmra={lmra} />;
}
